/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Search_In_DocumentInputs */

const en_read_along_search_in_document = /** @type {(inputs: Read_Along_Search_In_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search in document`)
};

const es_read_along_search_in_document = /** @type {(inputs: Read_Along_Search_In_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar en el documento`)
};

/**
* | output |
* | --- |
* | "Search in document" |
*
* @param {Read_Along_Search_In_DocumentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_search_in_document = /** @type {((inputs?: Read_Along_Search_In_DocumentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Search_In_DocumentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_search_in_document(inputs)
	return en_read_along_search_in_document(inputs)
});